import {
  FlexGroup,
  FlyoutHeader,
  Spacer,
  Tab,
  Tabs,
  Title,
} from '@antoree/ant-ui';
import { FormattedMessage } from 'react-intl';
import AvatarWithLabel from 'components/AvatarWithLabel';
import { TypicalUser } from 'services/user';
import { Tab as TabTestResult } from '../TestResult';

export type HeaderTestResultProps = {
  tabs: TabTestResult[];
  student: TypicalUser;
  onSelectedTabChanged: (tabId: number) => void;
  selectedTabId: number;
  isVisibleEdit: boolean;
};

const HeaderTestResult: React.FC<HeaderTestResultProps> = ({
  tabs,
  student,
  onSelectedTabChanged,
  selectedTabId,

  isVisibleEdit,
}) => {
  return (
    <>
      <FlyoutHeader>
        <Title size="m">
          {isVisibleEdit ? (
            <h2>
              <FormattedMessage
                id="test_result.header.edit"
                defaultMessage="Edit test result"
              />
            </h2>
          ) : (
            <h2>
              <FormattedMessage
                id="test_result.header.add"
                defaultMessage="Add test result"
              />
            </h2>
          )}
        </Title>
        <span>
          <FormattedMessage
            id="test_result.header.guideline"
            defaultMessage="Click <a>here</a> to view Guideline"
            values={{
              a: (chunks: any) => (
                <a
                  target="_blank"
                  className="text-primary"
                  href="https://freshdesk.antoree.com/support/solutions/articles/67000617570-how-can-i-confirm-trial-sessions-"
                >
                  {chunks}
                </a>
              ),
            }}
          />
        </span>
        <Spacer />
        <FlexGroup>
          <AvatarWithLabel student={student} />
        </FlexGroup>
        <Spacer />
        <Tabs expand>
          {tabs?.map((tab: TabTestResult, index) => (
            <Tab
              key={index}
              onClick={() => onSelectedTabChanged(tab.id)}
              isSelected={tab.id == selectedTabId}
            >
              {tab.name}
            </Tab>
          ))}
        </Tabs>
      </FlyoutHeader>
    </>
  );
};

export default HeaderTestResult;
